<ul class="labels">
    <!-- by now not clickable cursor pointer-->
    <li class="item-excluded" *ngFor="let label of excluded">
        <core-label [label]="label"></core-label>
    </li>
    <li class="item" [ngClass]="type" *ngFor="let label of labels" (click)="action(label)">
        <core-label [label]="label"></core-label>
    </li>
</ul>
